import { render, staticRenderFns } from "./GlobalSuccess.vue?vue&type=template&id=a7d32966&scoped=true&"
import script from "./GlobalSuccess.vue?vue&type=script&lang=js&"
export * from "./GlobalSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d32966",
  null
  
)

export default component.exports